import { Button, Menu, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { PRIMARY } from "../const/colors";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { countries } from "../const/countries";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectDetectedCountry } from "../features/user/userSlice";
import { getCountryName } from "../utils/tools";

const ArrowIcon = styled(ArrowDropDownIcon)`
  color: ${PRIMARY};
`;
const Img = styled.img`
  width: 26px;
  margin-right: 5px;
`;
const InputContainer = styled.div`
  flex: 1;
  position: relative;
  width: 100%;
  // margin: 0 0.5rem;
  > div {
    margin-top: 0.2rem;

    width: 100%;
    border: 1px solid ${PRIMARY};

    > input {
      width: 66%;
      outline: none;
      border: none;
      background-color: transparent;
      color: #fff;
      padding: 0.8rem 0.5rem;
      font-size: 0.8rem;
      transition: all 0.3s ease 0s;
    }
  }

  h3 {
    font-size: 0.8rem;
    font-weight: normal;
  }

  button {
    color: #fff;
    border-right: 1px solid ${PRIMARY};
    border-bottom: 1px solid ${PRIMARY};
    border-radius: 0;
    transition: all 0.3s ease;
    padding: 8px;
  }
  > div.error,
  > div.error button {
    border-color: #c21010;
  }
  > div.correct,
  > div.correct button {
    border-color: #28a745;
  }
  label {
    padding: 0px 1rem;
    font-size: 0.8rem;
    margin: 0.05rem 0px;
    display: inline-block;
    color: #fff;
  }
  div.flex {
    display: flex;
  }
  &:hover {
    > div:not(.error),
    > div:not(.error) > button {
      border-color: #fff;
    }
  }

  @media screen and (max-width: 768px) {
    text-align: center;
    > div {
      text-align: start;
      display: flex;
    }
    label,
    > div > input {
      font-size: 0.9rem;
    }
  }
`;

const InputPhoneNumber = ({
  value,
  handleChange,
  className,
  handleCountry,
  handleBlur,
  selectCountryCode,
  mycountry,
  areaCode,
}) => {
  const [t] = useTranslation("global");
  const [code, setCode] = useState(countries[0].code);
  const [country, setCountry] = useState(countries[0].flag);
  const [disabled, setDisabled] = useState(false);

  const countryDetected = useSelector(selectDetectedCountry);

  const [countryInfo, setCountryInfo] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);

  const open = Boolean(anchorEl);
  const openArea = Boolean(anchorEl2);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickArea = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseArea = () => {
    setAnchorEl2(null);
    handleChange({ target: { name: "area", value: areaCode } });
    handleBlur({ target: { name: "area", value: areaCode } });
  };
  const updateCountrySelect = (countryval) => {
    let countryname = getCountryName(countryval);
    handleSelectedCountry(countryname);
  };
  const handleSelectedCountry = (country) => {
    setCountry(country.flag);
    setCode(country.code);
    handleCountry(country.code);
    setAnchorEl(null);
  };

  const handleSelectedArea = (area) => {
    handleChange({ target: { name: "area", value: area } });
    handleBlur({ target: { name: "area", value: area } });
  };

  const change = (e) => {
    if (selectCountryCode) {
      selectCountryCode(code);
    }
    handleChange(e);
  };

  useEffect(() => {
    const inputnumber = document.getElementById("tlfRegister");
    inputnumber.onkeydown = (event) => {
      // Only allow if the e.key value is a number or if it's 'Backspace'
      if (isNaN(event.key) && event.key !== "Backspace") {
        event.preventDefault();
      }
    };

    const pais = countries.find((x) => x.flag === countryDetected);
    if (pais) {
      setCountryInfo(pais);
    } else {
      setCountryInfo(null);
    }
  }, []);

  useEffect(() => {
    const pais = countries.find((x) => x.flag === countryDetected);

    if (pais) {
      setDisabled(true);
      updateCountrySelect(countryDetected);
    } else {
      setDisabled(false);
      updateCountrySelect(mycountry);
    }
  }, [mycountry]);

  const handleChangeArea = ({ target }) => {
    const { value } = target;
    const regex = /^[0-9]*$/;
    if (regex.test(value)) {
      handleChange({ target: { name: "area", value: value } });
    }
  };

  return (
    <InputContainer>
      <label>{t("contact.lbl-phone")}</label>
      <div
        className={
          (countryInfo !== null &&
            countryInfo.area &&
            countryInfo.area.length > 0) ||
          (countryDetected === "BR" || country === 'VE' || country === 'BR')
            ? className + " flex"
            : className
        }
      >
        <Button
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          endIcon={<ArrowIcon />}
          onClick={handleClick}
          disabled={disabled}
          sx={{
            ":hover": {
              bgcolor: "#222",
            },
          }}
        >
          <Img
            alt=""
            src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${country}.svg`}
          />
          <h3 style={{ color: "#fff" }}>{code}</h3>
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          PaperProps={{ sx: { width: "fit-content" } }}
          sx={{ zIndex: 5000 }}
        >
          {countries.map((country) => (
            <MenuItem
              onClick={() => handleSelectedCountry(country)}
              key={`${country.code}-${country.lang}`}
            >
              <Img
                alt={country.flag}
                src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${country.flag}.svg`}
              />{" "}
              <h3 style={{ fontSize: "0.9rem" }}>{country.name}</h3>
            </MenuItem>
          ))}
        </Menu>

        {((countryInfo !== null &&
          countryInfo.area &&
          countryInfo.area.length > 0) ||
          country === "VE") && (
          <>
            <Button
              aria-controls={openArea ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openArea ? "true" : undefined}
              endIcon={<ArrowIcon />}
              onClick={handleClickArea}
              sx={{
                ":hover": {
                  bgcolor: "#222",
                },
              }}
            >
              <h3 style={{ color: "#fff" }}>{areaCode || "AREA"}</h3>
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl2}
              open={openArea}
              onClose={handleCloseArea}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              PaperProps={{ sx: { width: "fit-content" } }}
              sx={{ zIndex: 5000 }}
            >
              {countryInfo
                ? countryInfo.area.map((a) => (
                    <MenuItem onClick={() => handleSelectedArea(a)} key={a}>
                      <h3 style={{ fontSize: "0.9rem" }}>{a}</h3>
                    </MenuItem>
                  ))
                : countries.find((x) => x.flag === 'VE').area.map((a) => (
                    <MenuItem onClick={() => handleSelectedArea(a)} key={a}>
                      <h3 style={{ fontSize: "0.9rem" }}>{a}</h3>
                    </MenuItem>
                  ))}
            </Menu>
          </>
        )}

        {(countryDetected === "BR" || country === "BR") && (
          <input
            minLength={1}
            maxLength={4}
            type="text"
            placeholder={"AREA"}
            name="area"
            value={areaCode}
            onChange={handleChangeArea}
            onBlur={handleBlur}
            style={{
              width: "45px",
              borderRight: "1px solid #444",
              padding: 0,
              paddingLeft: "3px",
            }}
          />
        )}

        <input
          id="tlfRegister"
          minLength={country.phone}
          maxLength={country.phone}
          type="text"
          placeholder={t("sign-in.input-phone")}
          name="telefono"
          value={value}
          onChange={change}
          onBlur={handleBlur}
        />
      </div>
    </InputContainer>
  );
};

export default InputPhoneNumber;
